import { CommonModule, DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Duration, intervalToDuration, isValid, parseISO } from 'date-fns';
import { getDriverTableTimeStatusColor } from '../../helpers/get-driver-time-status.helper';

@Component({
  selector: 'app-time-status-indicator',
  standalone: true,
  imports: [CommonModule],
  providers: [DatePipe],
  templateUrl: './time-status-indicator.component.html',
  styleUrl: './time-status-indicator.component.scss'
})
export class TimeStatusIndicatorComponent {

  @Input() startTime: string | Date = '';
  @Input() signInTime: string | Date = '';
  @Input() durationSeconds?: number;
  @Input() showDuration: boolean = true;
  @Input() statusTable?: boolean = false;

  constructor(private datePipe: DatePipe) { }

  getDriverStatus(): 'success' | 'caution' | 'warning' | 'default' | null {
    let timeToCompare: string | null = null;
    timeToCompare = new Date().toISOString(); // this is for a scenario where we get details from driver ops modals queries as there is no start time.
    if (this.signInTime) {
      timeToCompare = this.signInTime.toString(); // this is for a scenario where we details from driver status table.
    }

    return getDriverTableTimeStatusColor(timeToCompare, this.startTime?.toString(), this.durationSeconds);
  }

  getStatusClass(status: string): string | null {
    return status ? `bg-${status}` : null;
  }

  getDisplayTime(): string {
    const isInvalidSignIn = this.signInTime === '0001-01-01T00:00:00.000Z';

    if (this.statusTable) {
      if (isInvalidSignIn) return '-';

      return this.showDuration
        ? this.formatDuration(this.signInTime, this.startTime.toString())
        : this.datePipe.transform(this.signInTime.toString(), 'HH:mm a') ?? '-';
    }

    return this.datePipe.transform(this.startTime.toString(), 'HH:mm a') ?? '-';
  }

  private formatDuration(signIn: string | Date, startTime: string, end?: string | Date): string {
    if (signIn) {
      const duration = this.getIntervalDuration(signIn, end)
      return this.formatTime(duration);
    }

    if (!isValid(parseISO(startTime))) {
      return '00h:00m';
    }
    
    const duration = this.getIntervalDuration(startTime, end)
    return this.formatTime(duration);
  }

  getIntervalDuration(startTime: string | Date, endTime?: string | Date): Duration {
    const duration = intervalToDuration({
      start: new Date(startTime),
      end: endTime ? new Date(endTime) : new Date()
    });

    return duration
  }

  formatTime(duration: Duration): string {
    const hours = String(duration.hours ?? 0).padStart(2, '0');
    const minutes = String(duration.minutes ?? 0).padStart(2, '0');
    return `${hours}h:${minutes}m`;
  }
}
